import React from 'react';
import PropTypes from 'prop-types';

import {
    Text,
    Spacer,
} from '@zillow/constellation';

const propTypes = {
    previews: PropTypes.array.isRequired,
};

const defaultPropTypes = {
    previews: [],
};

function BoostAdPreview({ title = '', body }) {
    // Would be ideal to set the height programmatically, but the iframe document can't be accessed
    const newBody = body.replace(/height="\d*"/, 'height="580px"').replace(/scrolling="yes"/, '/scrolling="no"/');

    return (
        <div>
            <Spacer paddingTop="md" paddingBottom="sm">
                <Text fontType="h6">
                    {title.toUpperCase()}
                </Text>
            </Spacer>
            <div dangerouslySetInnerHTML={{ __html: newBody }} />
        </div>
    );
}

function BoostAdPreviews({ previews }) {
    return (
        <div className="BoostAdPreviews">
            {previews.map(preview => (
                <BoostAdPreview
                    key={preview.cpmBoostType}
                    title={preview.cpmBoostType}
                    body={preview.body}
                />
            ))}
        </div>
    );
}

BoostAdPreviews.propTypes = propTypes;
BoostAdPreviews.defaultPropTypes = defaultPropTypes;

export default BoostAdPreviews;
